import React, { useState } from 'react';
import './AppInterface.css';
import ChatView from './ChatView';
import { analyzeChatsWithAI } from '../services/openAiService';
import { saveChatLog } from '../services/firebaseService';

function AppInterface() {
  const [activeTab, setActiveTab] = useState('chat');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [chatHistory, setChatHistory] = useState([
    {
      sender: 'PathwayGuide',
      content: 'Hei! Hvordan har du det i dag? Fortell meg om din arbeidsdag.',
      timestamp: new Date().toISOString()
    }
  ]);

  const handleSendMessage = async (message) => {
    // Add user message
    const userMessage = {
      sender: 'user',
      content: message,
      timestamp: new Date().toISOString()
    };
    
    setChatHistory(prev => [...prev, userMessage]);

    try {
      // Get user data from session storage
      const user = JSON.parse(sessionStorage.getItem('user'));
      
      // Get AI response
      const aiResponse = await analyzeChatsWithAI({ content: message }, user.email);
      
      if (aiResponse) {
        const aiMessage = {
          sender: 'PathwayGuide',
          content: aiResponse,
          timestamp: new Date().toISOString()
        };
        setChatHistory(prev => [...prev, aiMessage]);

        // Save chat log to Firebase
        await saveChatLog(user.email, message, aiResponse);
      } else {
        // Handle error case
        const errorMessage = {
          sender: 'PathwayGuide',
          content: 'Beklager, jeg kunne ikke prosessere meldingen din akkurat nå. Vennligst prøv igjen senere.',
          timestamp: new Date().toISOString()
        };
        setChatHistory(prev => [...prev, errorMessage]);
      }
    } catch (error) {
      console.error('Error getting AI response:', error);
      const errorMessage = {
        sender: 'PathwayGuide',
        content: 'Det oppstod en feil. Vennligst prøv igjen senere.',
        timestamp: new Date().toISOString()
      };
      setChatHistory(prev => [...prev, errorMessage]);
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setIsMenuOpen(false);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'chat':
        return <ChatView messages={chatHistory} onSendMessage={handleSendMessage} />;

      case 'reminder':
        return (
          <div className="feature-container">
            <h2>Påminnelser</h2>
            <div className="reminder-list">
              <div className="reminder-item">
                <h3>Ukentlig Refleksjon</h3>
                <p>Husk å fylle ut din ukentlige refleksjon innen fredag</p>
              </div>
              <div className="reminder-item">
                <h3>Teambuilding</h3>
                <p>Neste teambuilding er planlagt for neste uke</p>
              </div>
            </div>
          </div>
        );

      case 'journal':
        return (
          <div className="feature-container">
            <h2>Journal</h2>
            <div className="journal-section">
              <textarea
                className="journal-input"
                placeholder="Skriv dine tanker og refleksjoner her..."
                rows="10"
              ></textarea>
              <button className="save-button">Lagre</button>
            </div>
          </div>
        );

      case 'improvements':
        return (
          <div className="feature-container">
            <h2>Forbedringer</h2>
            <div className="improvements-form">
              <textarea
                className="improvement-input"
                placeholder="Del dine forslag til forbedringer..."
                rows="8"
              ></textarea>
              <button className="submit-button">Send inn</button>
            </div>
          </div>
        );

      default:
        return <div>Velg en funksjon fra menyen</div>;
    }
  };

  return (
    <div className="app-interface">
      <div className="app-header">
        <button 
          className="menu-button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          ☰
        </button>
      </div>

      {isMenuOpen && (
        <div className="menu-overlay" onClick={() => setIsMenuOpen(false)}>
          <div className="menu-content" onClick={e => e.stopPropagation()}>
            <button 
              className={`menu-item ${activeTab === 'chat' ? 'active' : ''}`}
              onClick={() => handleTabClick('chat')}
            >
              💬 Chat
            </button>
            <button 
              className={`menu-item ${activeTab === 'reminder' ? 'active' : ''}`}
              onClick={() => handleTabClick('reminder')}
            >
              🔔 Påminnelse
            </button>
            <button 
              className={`menu-item ${activeTab === 'journal' ? 'active' : ''}`}
              onClick={() => handleTabClick('journal')}
            >
              📔 Journal
            </button>
            <button 
              className={`menu-item ${activeTab === 'improvements' ? 'active' : ''}`}
              onClick={() => handleTabClick('improvements')}
            >
              📈 Forbedringer
            </button>
          </div>
        </div>
      )}

      <div className="app-content">
        {renderContent()}
      </div>
    </div>
  );
}

export default AppInterface; 